import React from 'react';
import ReactDOM from 'react-dom/client';
import { enableMapSet } from 'immer';
// Force lucide-react to initialize before any component imports it
// This prevents TDZ errors when Rollup reorders module initialization
import 'lucide-react';
import App from './App';
import './i18n';
import './index.css';
import { initializeAnalyticsConsent } from './features/marketing/analyticsConsent';
import { registerSW } from 'virtual:pwa-register';

// Enable Immer's MapSet plugin for Set/Map support in Zustand stores
enableMapSet();

// Register service worker with auto-update
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    // New version available - reload to update
    // Auto-refresh for seamless updates
    updateSW(true);
  },
  onOfflineReady() {
    console.log('[PWA] App ready for offline use');
  },
  onRegisteredSW(_swUrl, registration) {
    // Check for updates every 15 minutes
    if (registration) {
      setInterval(() => {
        registration.update();
      }, 15 * 60 * 1000);
    }
  },
});

// Honor visitor consent before loading optional audience measurement.
initializeAnalyticsConsent();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
